import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';

const PageHeadingStyled = styled.div`
  display: flex;
  padding: 1.5rem 3rem;
  h1 {
    display: inline-block;
    font-weight: normal;
    .icon {
      margin-right: 0.75rem;
      position: relative;
      top: 0.25rem;
      svg {
        width: 2rem;
        * {
          stroke: ${css.primaryColor};
        }
      }
    }
  }
  .left {
    margin-right: auto;
    ${css.flexVerticalCenter}
  }
  .right {
    margin-left: auto;
    ${css.flexVerticalCenter}
    .btn {
      margin-left: 1rem;
    }
  }
  ${css.compactMedia} {
    padding: 1.5rem;
    /* Beside the sidebar a long title and a wide button group no longer share the row: the group keeps
       its labels on one line and drops under the title, right-aligned, when it must. */
    flex-wrap: wrap;
    .left, .right { min-width: 0; }
    .right .btn { white-space: nowrap; }
  }
  ${css.mobileMedia} {
    padding: 1rem;
    /* Title and actions cannot share a 390px row: the button group ran off the right edge on every
       page. Wrap it under the title, laid out as a wrapping row rather than the desktop column. */
    flex-wrap: wrap;
    .left, .right { margin: 0; min-width: 0; }
    .right {
      width: 100%;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: 0.5rem;
      margin-top: 0.75rem;
      .btn { margin-left: 0; }
    }
    h1 {
      font-size: 1.65rem;
      .icon {
        margin-right: 0.25rem;
        position: relative;
        top: 0.25rem;
        svg {
          width: 1.65rem;
          * {
            stroke: ${css.primaryColor};
          }
        }
      }
    }
  }
`;

interface PageHeadingProps {
  className?: string,
  left?: React.ReactNode,
  center?: React.ReactNode,
  right?: React.ReactNode,
}

/** Page header bar with optional left, center, and right slots. */
export const PageHeading = (props: PageHeadingProps) => {
  return (
    <PageHeadingStyled className={`page-heading${props.className ? ` ${props.className}` : ''}`}>
      {props.left && <div className="left">{props.left}</div>}
      {props.center && <div className="center">{props.center}</div>}
      {props.right && <div className="right">{props.right}</div>}
    </PageHeadingStyled>
  );
};